module.exports = __webpack_public_path__ + "static/media/Serbia.8177285b.png";